.container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 320px;
}
.leftPane {
  width: 420px;
  min-width: 320px;
  max-width: 540px;
  border-right: 1px solid var(--bs-border-color, #dee2e6);
  display: flex;
  flex-direction: column;
}
.rightPane {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.header {
  background: var(--bs-light, #f8f9fa);
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}
.body {
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.table {
  margin: 0;
  border: 0;
}
.table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--bs-light, #f8f9fa);
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}
.row {
  height: var(--row-height, 28px);
}
.nameCell {
  white-space: nowrap;
}
.indent {
  display: inline-block;
  width: calc(var(--level, 0) * 16px);
}
.toggle {
  border: none;
  background: transparent;
  padding: 0 6px;
  cursor: pointer;
}
.rowNumberCell {
  text-align: right;
  width: 48px;
}

.timelineHeader {
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}
.timelineHeader {
  scrollbar-width: none;
}
.timelineHeader::-webkit-scrollbar {
  display: none;
}
.timelineHeaderInner {
  position: relative;
  display: flex;
  flex-direction: column;
}
.weekRow {
  display: flex;
}
.weekCell {
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 0;
  border-right: 1px solid var(--bs-border-color, #eee);
  background: var(--bs-light, #f8f9fa);
}
.dayRow {
  display: flex;
}
.dayCell {
  width: var(--col-width, 28px);
  min-width: var(--col-width, 28px);
  text-align: center;
  font-size: 12px;
  padding: 4px 0;
  border-right: 1px solid var(--bs-border-color, #eee);
}
.dayWeekend {
  background: #f2f2f2;
}

.timelineBody {
  position: relative;
  overflow: auto;
  height: 100%;
}
.gridSvg {
  display: block;
}
.gridLine {
  stroke: #e9ecef;
  stroke-width: 1px;
}
.weekendRect {
  fill: #f2f2f2;
}
.todayLine {
  stroke: #0d6efd;
  stroke-width: 2px;
  opacity: 0.6;
}

.bar {
  fill: #0d6efd;
  rx: 3px;
  ry: 3px;
}
.barProgress {
  fill: #6ea8fe;
  rx: 3px;
  ry: 3px;
}
.barMilestone {
  fill: #198754;
}
.barLabel {
  font-size: 11px;
  fill: #212529;
}
